import { JsonObject } from 'json2typescript';

import { IdInterface } from '../../../core';
import { ValidationInterface, ValidationStatus } from '../../../core';

@JsonObject('Validation')
export class Validation implements ValidationInterface {
    private readonly _id: IdInterface = undefined;

    private _status: ValidationStatus = undefined;

    private _reason: string = undefined;

    constructor(id: IdInterface) {
        this._id = id;
        this._reason = '';
    }

    get id(): IdInterface {
        return this._id;
    }

    get status(): ValidationStatus {
        return this._status;
    }

    set status(value: ValidationStatus) {
        this._status = value;
    }

    get reason(): string {
        return this._reason;
    }

    set reason(value: string) {
        this._reason = value;
    }

    isValid() {
        return this._status === ValidationStatus.VALID;
    }
}
